import { UPDATE_REPORT_ADDRESS_API } from 'constants/AppConstants';
import { constructUrlWithUserDetails } from 'utils/app.utils';

export default async (reportId, requestBody) => {
  try {
    const baseUrl = UPDATE_REPORT_ADDRESS_API.replace(':reportId', reportId);
    const URL = constructUrlWithUserDetails(baseUrl);

    const response = await fetch(URL, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(requestBody),
      skipAuthHeader: true,
    });

    if (response.status !== 200) return { ok: false, status: response.status };

    return { ok: true };
  } catch (error) {
    return { ok: false, json: { errorDescription: 'Internal Server Error' } };
  }
};
